import { ToastProgrammatic as Toast } from 'buefy'

const show = config => {
  const baseConfig = { duration: 2000 }
  Toast.open(Object.assign(baseConfig, config))
}

const ToastService = {
  open: config => {
    show(config)
  },
  success: message => {
    const baseConfig = { type: 'is-success' }
    show(Object.assign(baseConfig, { message }))
  },
  error: message => {
    const baseConfig = { type: 'is-danger' }
    show(Object.assign(baseConfig, { message }))
  }
}

export default ToastService
